import { render, staticRenderFns } from "./DataEmpCustom2.vue?vue&type=template&id=6f79914e"
import script from "./DataEmpCustom2.vue?vue&type=script&lang=ts"
export * from "./DataEmpCustom2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports